import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import accountService from "@/services/account.service";

const loadingNextpage = ref(false);
const accountLoading = ref(false);

const useAccountNavigation = () => {

    const components = [
        {
            number: 1,
            name: "My bookings"
        },
        {
            number: 2,
            name: "Settings"
        }
    ]

    const router = useRouter();

    const currentPage = computed(() => {
        return components.find(p => p.number === parseInt(router.currentRoute.value.query.p?.toString() ?? "1")) ?? components[0];
    })

    const goToPage = (page: number) => {
        router.push({
            path: router.currentRoute.value.path, query: {
                p: page
            }
        });
    }
    
    const resetBooking = () : Promise<string> => {
    
    		return new Promise((resolve, reject) => {
    			accountService
    				.newBooking()
    				.then((resp) => {
    						resolve(resp);
    				})
    				.catch((err) => {
    						reject(err);
    				});
    			});
    }

    return { currentPage, goToPage, components, loadingNextpage, resetBooking, accountLoading }
}

export default useAccountNavigation;